import DefaultEntityConsult from 'components/form/DefaultEntityConsult'
import Cliente from 'entity/Cliente'
import React, { useState } from 'react'
import { usePerfil } from 'useAuth';

export default function ClienteConsulta() {
    const [list,] = useState([])
    const perfil = usePerfil();
    let tipoPerfil = 'cliente'
    if (perfil) {
        if (perfil.grupoPermissao) {
            if (perfil.grupoPermissao.uid === "r9jrEQXznNgjrZTGCfch") {
                tipoPerfil = 'admin'
            }
            if (perfil.grupoPermissao.uid === "RECT03jkyTQW9B2OMz47") {
                tipoPerfil = 'tecnico'
            }
            if (perfil.grupoPermissao.uid === "-OXwisN4fkQV3l7Uzeui") {
                tipoPerfil = 'lider'
            }
        }
    }



    const extraQuery = (col) => {


        if (perfil) {
            console.log('tipoPerfil', tipoPerfil)
            if (tipoPerfil === "cliente") col = col.where('perfisAutorizado.' + perfil.uid, '==', true);
            if (tipoPerfil === "tecnico") col = col.where('perfisAutorizado.' + perfil.uid, '==', true);
            if (tipoPerfil === "lider") {
                // se mais de 10 clientes, pode ser que precisaremos de uma nova abordagem
                // existe um limitador de 10 no operador 'in'
                if (perfil.clientesPermitidos && Array.isArray(perfil.clientesPermitidos) && perfil.clientesPermitidos.length > 0) {
                    col = col.where('cliente.uid', 'in', perfil.clientesPermitidos.map(cliente => cliente.uid));
                }
            }
        } else {
            col = col.where('uid', '==', '');
        }
        return col;
    }
    // eslint-disable-next-line no-unused-vars
    const processarList = () => {
        console.log('processarList', list)

        list.forEach(v => {
            if (v.status === "ATIVO") {
                let novoStatus = null

                if (!v.nome || !v.nome.trim() || v.nome === ".") {
                    console.log('!v.nome', v)
                    novoStatus = "DELETAR"
                }

                if (novoStatus) {

                    let entity = new Cliente()

                    entity.update({ uid: v.uid, status: novoStatus });

                    entity.save().then(() => {

                    })
                }

            }
        });

    }

    return (
        <>
            {/* <div><Button onClick={processarList}>Corrige Status</Button></div> */}
            <DefaultEntityConsult
                // onFilteredValues={setList}
                actionsAuth={['r9jrEQXznNgjrZTGCfch'/*, 'RECT03jkyTQW9B2OMz47'*/]} //admin ou tecnico
                EntityClass={Cliente}
                initialFilters={{ status: "ATIVO" }}
                extraQuery={extraQuery}
                titulo="Clientes Consulta"
                routeForm="_cliente"
                showEdit={true}
                showDelete={true}
            />
        </>
    )
}
